<template>
    <header class="bg-first p-4">
        <div class="container d-flex align-items-center flex-wrap py-4">
            <div class="col-12 col-sm-6 text-center text-sm-start mb-4 mb-sm-0">
                <a href="https://www.atb.bergamo.it/it">
                    <img :src="require(`@/assets/img/tenants/${omsApiKey}.svg`)" alt="tenant logo">
                </a>
            </div>
            <div class="col-12 col-sm-6 text-center text-sm-end">
                <LanguagesSelect class="select-auth"/>
            </div>
        </div>
    </header>
</template>

<script>
import { mapGetters } from 'vuex'
import LanguagesSelect from '@/components/LanguagesSelect.vue'
export default {
    name: 'HeaderComp',
    computed: {
        ...mapGetters(['omsApiKey'])
    },
    components: {
        LanguagesSelect
    }
}
</script>

<style lang="scss" scoped>
    header {
        img {
            width: 40%;
        }
    }

    @media screen and (max-width: 992px) {
        header {
            img {
                width: 75%;
            }
        }
    }
</style>